export default __webpack_public_path__ + "static/media/do.5994315b.jpg";